import { gql } from '@apollo/client';

export const getHomeBannerData = gql`
query getHomeBanner {
    getHomeBanner {
        id
        name
    }
}
`;

export const getHomePageData = gql`
query getHomeData {
  getHomeData {
    result {
      id
      title
      content
      isEnable
      getHomeBanner {
        id
        name
        enable
      }
      getImageBanner {
        id
        title
        description
        buttonLabel
        image
      }
      getPopularLocationAdmin {
        id
        location
        locationAddress
        image
        isEnable
        createdAt
        updatedAt
      }
      getStaticInfo {
        title
        content
        name
        image
        isEnable
      }
      getRecommend {
        id
        title
        beds
        bookingType
        coverPhoto
        reviewsCount
        reviewsStarRating
        listPhotos {
          id
          name
          type
          status
        }
        user {
          id
          userBanStatus
        }
        listingData {
          basePrice
          currency
        }
        settingsData {
          listsettings {
            id
            itemName
          }
        }
        wishListStatus
        isListOwner
      }
      getMostViewedListing {
        id
        title
        beds
        bookingType
        coverPhoto
        reviewsCount
        reviewsStarRating
        listPhotos {
          id
          name
          type
          status
        }
        user {
          id
          userBanStatus
        }
        listingData {
          basePrice
          currency
        }
        settingsData {
          listsettings {
            id
            itemName
          }
        }
        wishListStatus
        isListOwner
      }
    }
  }
}
`;

export const getImageBannerData = gql`
query getImageBanner {
    getImageBanner {
        id
        title
        description
        buttonLabel
        image
    }
}
`;

export const GetMostViewedListing = gql`
query GetMostViewedListing {
  GetMostViewedListing {
    id
    title
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount,
    reviewsStarRating,
    listPhotos {
      id
      name
      type
      status
    }
    user {
      id
      userBanStatus
    }
    listingData {
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
      }
    }
    wishListStatus
    isListOwner
  }
}
`;

export const getPopularLocationAdmin = gql`
query getPopularLocationAdmin {
  getPopularLocationAdmin{
    id
    location
    locationAddress
    image
    isEnable
    createdAt
    updatedAt
  }
}
`;

export const getRecommend = gql`
query getRecommend {
  getRecommend {
    id
    title
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount,
    reviewsStarRating,
    listPhotos {
      id
      name
      type
      status
    }
    user {
      id
      userBanStatus
    }
    listingData {
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
      }
    }
    wishListStatus
    isListOwner
  }
}
`;

export const getStaticInfoData = gql`
query getStaticInfo {
  getStaticInfo {
        title
        content
        name
        image
        isEnable
      }
}
`;
